<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5 px-3" to="/">
                <img src="img/brand/zwapit-logo-white-stroke.png" style="width: 100px;">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="../index.html" style="font-weight: 700; font-size: 30px;">
                        <img src="img/brand/zwapit-logo.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center ml-auto">
                <li class="nav-item">
                    <router-link to="/" class="nav-link" role="button">
                        <i class="fa fa-home d-lg-none"></i>
                        <span class="nav-link-inner--text">Home</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/contact" class="nav-link" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Contact Us</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/privacy" class="nav-link" role="button">
                        <i class="ni ni-lock-circle-open d-lg-none"></i>
                        <span class="nav-link-inner--text">Privacy Policy</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/terms" class="nav-link" role="button">
                        <i class="ni ni-single-copy-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Terms of Service</span>
                    </router-link>
                </li>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="#" target="_blank"
                       class="btn btn-info btn-icon">
                <span class="btn-inner--icon">
                  <i class="fa fa-cloud-download mr-2"></i>
                </span>
                        <span class="nav-link-inner--text">Download Our App</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton
  }
};
</script>
<style scoped>
:deep(.navbar-collapse-header img) {
    margin-top: -13px;
}
.navbar-brand {
    font-weight: bold;
    font-size: 30px;
    img {
        height: 35px;
    }
}
.navbar {
    padding: 1rem 1rem;
    .nav-link {
        font-weight: 700;
    }
}
</style>